type GrantedByProps = {
  name: string;
};

const GrantedBy: React.FC<GrantedByProps> = ({ name }) => {
  return <p className="text-white75 text-sm">Granted by: {name}</p>;
};

export default GrantedBy;
